const mapStateToProps = state => {
  return {
    i18n: state.I18nReducers,
    trial: state.TrialReducers,
  };
};
export default mapStateToProps;